import { ComponentProps } from 'react';
import { joinClassNames } from '../../utils';
import { Icon, IconName } from '../Graphics';
import styles from './Toggle.module.scss';

type ToggleProps = {
  size?: 'Small' | 'Large';
  label: string;
} & Omit<ComponentProps<'input'>, 'type' | 'size' | 'className'>;

export const Toggle = ({ checked, label, size = 'Small', ...props }: ToggleProps) => {
  return (
    <label
      className={joinClassNames(
        styles.root,
        checked ? styles.selected : undefined,
        size === 'Large' ? styles.large : undefined
      )}
      aria-label={`Toggle ${label}`}
    >
      <input className={styles.input} type="checkbox" checked={checked} {...props} />
      <div className={styles.container}>
        <div className={styles.checkedIcon}>
          <Icon
            name={IconName.Check}
            size={{ width: size === 'Large' ? '14px' : '12px', height: size === 'Large' ? '14px' : '12px' }}
          />
        </div>
        <div className={styles.toggle}></div>
      </div>
    </label>
  );
};

Toggle.displayName = 'Toggle';
